<template>
  <table v-if="isLoading" class="table datatable table-striped mt-3">
    <slot name="thead"></slot>
    <thead :class="className.thead">
      <tr>
        <th
          v-for="(field, index) in _fields"
          :key="index"
          :class="{
            [className.sort]: true,
            sorting: field.sortable,
            sorting_asc: showAscClass(field),
            sorting_desc: showDescClass(field),
            [field.thClassName || '']: true,
          }"
          :style="{
            width: field.width ? field.width + 'px' : 'auto',
          }"
          @click="field.sortable ? sortChange(field) : ''"
        >
          <span>
            <strong class="pre-formatted">{{ field.name }}</strong>
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(data, index) in proccessDatas">
        <tr v-if="data" :key="'data' + index" :class="data.trClassName">
          <td v-for="(field, i) in _fields" :key="i" :class="field.className">
            <slot :name="field.key" :data="data">
              {{ data[field.key] }}
            </slot>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import HardwordMixins from '@/mixins/Hardword'; // for 難字更新
const { _ } = window;
export default {
  mixins: [ HardwordMixins],
  props: {
    datas: {
      type: Array,
      required: true,
    },
    _fields: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
    constantSortKey: {
      type: Array,
      default: () => [],
    },
    constantSortType: {
      type: Array,
      default: () => [],
    },
    initSort: {
      type: Object,
    },
    isSelectable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sort: this.initSort || {
        key: '',
        type: '',
      },
      isLoading: true,
      extraSupportSortType: { adesc: 'desc', aasc: 'asc' },
    };
  },
  methods: {
    isStandardSortType(x) {
      return ['asc', 'desc'].includes(x);
    },
    transferSortType(type) {
      return this.extraSupportSortType[type] || type;
    },
    switchSortType(type) {
      return (
        ['asc', 'desc']
          .filter(x => x === type)
          .map(x => (x === 'asc' ? 'desc' : 'asc'))
          .shift() || type
      );
    },
    sortChange(field) {
      this.isLoading = false;
      const { key, orderByMultiKey, orderByMultiType } = field;
      if (orderByMultiKey) {
        this.sort.type = _.isEqual(this.sort.key, orderByMultiKey)
          ? this.sort.type.map(this.switchSortType)
          : orderByMultiType;
        this.sort.key = orderByMultiKey;
      } else {
        this.sort.type = this.sort.key == key ? (this.sort.type === 'asc' ? 'desc' : 'asc') : 'asc';
        this.sort.key = key;
      }

      this.$nextTick(() => (this.isLoading = true));
      this.$emit('changeSort', this.sort);
    },
    showAscClass(field) {
      if (_.isArray(this.sort.type)) {
        return (
          _.isEqual(this.sort.key, field.orderByMultiKey) &&
          this.sort.type.filter(this.isStandardSortType).every(x => x === 'asc')
        );
      } else {
        return this.sort.key === field.key && this.sort.type === 'asc';
      }
    },
    showDescClass(field) {
      if (_.isArray(this.sort.type)) {
        return (
          _.isEqual(this.sort.key, field.orderByMultiKey) &&
          this.sort.type.filter(this.isStandardSortType).every(x => x === 'desc')
        );
      } else {
        return this.sort.key === field.key && this.sort.type === 'desc';
      }
    },
  },
  computed: {
    orderByKey() {
      return this.sort.key ? [].concat(this.sort.key, this.constantSortKey) : this.constantSortKey;
    },
    orderByType() {
      return this.sort.type
        ? [].concat(this.sort.type.map(this.transferSortType), this.constantSortType)
        : this.constantSortType;
    },
    proccessDatas() {
      return this.orderByKey.length ? window._.orderBy(this.datas, this.orderByKey, this.orderByType) : this.datas;
    },
    className() {
      switch (this.theme) {
        case 'red':
          return {
            thead: 'thBorderCustSuggest b-red',
            sort: 'b-red',
          };
        case 'blue':
          return {
            thead: 'other_thead thBorderCustOther other-blue',
            sort: 'b-blue',
          };
        case 'green':
          return {
            thead: 'default_thead thBorderCust text-green',
            sort: 'b-green',
          };
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pre-formatted {
  white-space: pre-line;
}

.table.datatable {
  thead {
    &.bg-white {
      background-color: white;
    }
    &.default_thead {
      background-color: rgba(0, 122, 177, 0.1);
    }
    &.other_thead {
      background-color: rgb(229, 241, 247);
    }
    &.other-blue {
      color: #007ab1;
    }
    &.b-red {
      color: #de4054;
    }
    &.thBorderCust {
      border: solid 1px #53c480;
      background-color: rgb(229, 246, 236);
    }
    &.thBorderCustOther {
      border: #0f82b5 1px solid !important;
    }
    &.thBorderCustSuggest {
      border: #de4054 1px solid;
      background-color: rgba(222, 64, 84, 0.1);
    }
    tr > th {
      height: 48px;
      padding: 9px 10px;
      &:not(:last-child) {
        border-right: 1px dotted #c2c4c7;
      }
      &.b-red {
        padding: 8px 10px;
        &:last-child {
          border-bottom: #de4054 1px solid;
          border-right: #de4054 1px solid;
        }
        &.sorting {
          &::before {
            border-bottom: rgba(222, 64, 84, 0.5) 6px solid;
          }
          &::after {
            border-top: rgba(222, 64, 84, 0.5) 6px solid;
          }
        }
        &.sorting_asc:before {
          border-bottom: 6px solid #de4054;
        }
        &.sorting_desc:after {
          border-top: 6px solid #de4054;
        }
      }
      &.b-green {
        &:last-child {
          border-bottom: #53c480 1px solid;
          border-right: #53c480 1px solid;
        }
        &.sorting {
          &::before {
            border-bottom: rgba(2, 122, 57, 0.5) 6px solid;
          }
          &::after {
            border-top: rgba(2, 122, 57, 0.5) 6px solid;
          }
        }
        &.sorting_asc:before {
          border-bottom: 6px solid #027a39;
        }
        &.sorting_desc:after {
          border-top: 6px solid #027a39;
        }
      }
      &.b-blue {
        &:last-child {
          border-bottom: #007ab1 1px solid;
          border-right: #007ab1 1px solid;
        }
        &.sorting {
          &::before {
            border-bottom: rgba(0, 122, 177, 0.5) 6px solid;
          }
          &::after {
            border-top: rgba(0, 122, 177, 0.5) 6px solid;
          }
        }
        &.sorting_asc:before {
          border-bottom: 6px solid #007ab1;
        }
        &.sorting_desc:after {
          border-top: 6px solid #007ab1;
        }
      }
    }
  }
  tbody {
    tr > td {
      &:first-child {
        padding-left: 10px;
        padding-top: 10px;
      }
      &:last-child {
        border-right: 1px solid rgb(194, 196, 199);
      }
    }
  }
}

.bg-white {
  background-color: white;
}
.bg-gray {
  background-color: #f5f5f5;
}
</style>
